// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, UnorderedList, TypoListItem as ListItem } from '@gandi/ui';

function NextSteps(): React.MixedElement {
  const { __ } = useTranslator();

  const STEPS = [
    __('Log in or register with Gandi.'),
    __('Finalize your order and proceed to payment.'),
    __('Follow the automatic configuration of your products.'),
  ];

  return (
    <Base padding="small" backgroundColor="white">
      <Base tagName="p" size="big" weight="semibold" marginBottom="small">
        {__('Next steps')}
      </Base>

      <UnorderedList gap="xxsmall" padding="none">
        {STEPS.map((t, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <ListItem key={`tip-${idx}`}>{t}</ListItem>
        ))}
      </UnorderedList>
    </Base>
  );
}

export default NextSteps;
